module.exports = __webpack_public_path__ + "static/media/Trailhead.88be4a12.svg";